export const translations = {
  en: {
    paragraph: 'There has been an error processing your request.',
    try_again: 'Please try again.'
  },
  es: {
    paragraph: 'Se ha producido un error al procesar su solicitud.',
    try_again: 'Por favor, inténtelo de nuevo.'
  }
};
